module.exports = "<p>\r\n  report works!\r\n</p>\r\n"